import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Entité juridique — immeuble multi-étages duotone */
export const CompanyIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Fenêtres menthe */}
      <rect x="7" y="8" width="2" height="2" rx="0.4" fill="var(--equiply-icon-bg)" />
      <rect x="11" y="8" width="2" height="2" rx="0.4" fill="var(--equiply-icon-bg)" />
      <rect x="7" y="12" width="2" height="2" rx="0.4" fill="var(--equiply-icon-bg)" />
      <rect x="11" y="12" width="2" height="2" rx="0.4" fill="var(--equiply-icon-bg)" />
      {/* Carcasse bâtiment principal */}
      <path
        d="M4.5 20.5V5a1.5 1.5 0 0 1 1.5-1.5h8A1.5 1.5 0 0 1 15.5 5v15.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Aile droite */}
      <path
        d="M15.5 10H18a1.5 1.5 0 0 1 1.5 1.5v9"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Porte */}
      <path
        d="M8.5 20.5v-3a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5v3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5"
      />
      {/* Sol */}
      <path
        d="M3 20.5h18"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
CompanyIcon.displayName = "CompanyIcon";
